import Default from './Default';

export default [() => (angular.extend({}, Default.definition, {
    link: function ($scope) {
        $scope.rightAligned = true;
        if (typeof Default.definition.link === 'function') {
            return Default.definition.link.apply(this, arguments);
        }
    }
}))];